export type FormCardStatus =
  | "Not Started"
  | "In Progress"
  | "Completed"
  | "Optional"
  | "Uploaded"
  | "Feedback Received";

export function getFormButtonText(
  status: FormCardStatus | undefined,
  canEditCompletedForm = false,
): string {
  switch (status) {
    case "Not Started":
      return "Start Form";
    case "In Progress":
      return "Continue";
    case "Completed":
      return canEditCompletedForm ? "Edit Form" : "View Form";
    case "Feedback Received":
      return "Update";
    default:
      return "";
  }
}

export function hasFormButtonLink(buttonText: string): boolean {
  const normalized = buttonText.toLowerCase();
  return ["start", "continue", "edit", "view", "update"].some((prefix) =>
    normalized.startsWith(prefix),
  );
}
